import type { Feature, FeatureLink } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { IContentItem } from "services/content-manager/models";
import getPathByType from "utils/getPathByType";

import { getUrlPathTypeByCategory } from "./articleCardResolver";
import type { ResolvedFeatureLink } from "./featureLinkResolver";
import featureLinkResolver from "./featureLinkResolver";
import imageResolver from "./imageResolver";

export interface ResolvedFeature {
    ctaLabel?: string;
    link: ResolvedFeatureLink | null;
    id: string;
    type: ContentTypeCodenames.Feature;
    codename: string;
    isSmall?: boolean;
}

const linkResolver = (data: IContentItem) => {
    switch (data?.system?.type) {
        case ContentTypeCodenames.ArticlePage:
        case ContentTypeCodenames.PRArticlePage:
            const categoryToUse = data.elements?.category?.value[0]?.codename;
            const relativeUrl = getPathByType({
                slug: data.elements.urlSlug.value,
                type: categoryToUse ? getUrlPathTypeByCategory(categoryToUse) : data?.system?.type,
            });
            return {
                image: imageResolver(data.elements.image.linkedItems[0]),
                title: data.elements.title.value as string,
                path: relativeUrl,
            };

        case ContentTypeCodenames.FeatureLink:
            return featureLinkResolver(data as FeatureLink);
        default: {
            return null;
        }
    }
};

const featureResolver = (data: Feature): ResolvedFeature => {
    return {
        ctaLabel: data.elements.ctaLabel?.value,
        link: linkResolver(data.elements.link.linkedItems[0]),
        id: data.system.id,
        type: ContentTypeCodenames.Feature,
        codename: data.system.codename,
        isSmall: data.elements.cardSize.value.length !== 0,
    };
};

export default featureResolver;
